import { render, staticRenderFns } from "./idcardOcr.vue?vue&type=template&id=7d3fa7cd&scoped=true&"
import script from "./idcardOcr.vue?vue&type=script&lang=js&"
export * from "./idcardOcr.vue?vue&type=script&lang=js&"
import style0 from "./idcardOcr.vue?vue&type=style&index=0&id=7d3fa7cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3fa7cd",
  null
  
)

export default component.exports